/* eslint import/prefer-default-export: 0 */

// dependencies
import moment from "moment";
import { fromJS } from "immutable";
import { CreateProcess } from "redux-process";
import { parse, toDate, format } from "date-fns";

// utils
import objectIDToDate from "Utils/objectIDToDate";
import objectToQueryString from "Utils/objectToQueryString";

// selectors
import { getCurrentEnvironmentName } from "Selectors/app";

export const fetchNotificationEvents = CreateProcess({
	method: "GET",
	name: "fetchNotificationEvents",
	type: "NOTIFICATIONS:GETEVENTS",

	request: (props, { getState }) => {
		const { query = {} } = props;

		const state = getState();
		const environment = getCurrentEnvironmentName(state);
		const queryString = objectToQueryString(query);

		return {
			url: `/${environment}/notifications/events/?${queryString}`,
		};
	},

	success: (response) => {
		response.data.events.forEach((evt) => {
			const event = evt;

			event.createdAt = objectIDToDate(event._id);
		});

		return fromJS(response.data);
	},
});

export const fetchScheduledNotifications = CreateProcess({
	method: "GET",
	name: "fetchScheduledNotifications",
	type: "NOTIFICATIONS:GETSCHEDULEDNOTIFICATIONS",

	request: (props, { getState }) => {
		const { query = {} } = props;

		const state = getState();
		const environment = getCurrentEnvironmentName(state);
		const queryString = objectToQueryString(query);

		return {
			url: `/${environment}/notifications/scheduled/?${queryString}`,
		};
	},

	success: (response) => {
		response.data.scheduledNotifications.forEach((evt) => {
			const event = evt;

			event.createdAt = objectIDToDate(event._id);
		});

		return fromJS(response.data);
	},
});

export const fetchNotificationEmails = CreateProcess({
	method: "GET",
	name: "fetchNotificationEmails",
	type: "NOTIFICATIONS:GETNOTIFICATIONEMAILS",

	request: (props, { getState }) => {
		const { query = {} } = props;

		const state = getState();
		const environment = getCurrentEnvironmentName(state);
		const queryString = objectToQueryString(query);

		return {
			url: `/${environment}/notifications/emails/?${queryString}`,
		};
	},

	success: (response) => {
		response.data.notificationEmails.forEach((e) => {
			const email = e;
			email.createdAt = objectIDToDate(email._id);
		});

		return fromJS(response.data);
	},
});

export const fetchNotificationSnapshots = CreateProcess({
	method: "GET",
	name: "fetchNotificationSnapshots",
	type: "NOTIFICATIONS:GETNOTIFICATIONSNAPSHOTS",

	request: (props, { getState }) => {
		const state = getState();
		const environment = getCurrentEnvironmentName(state);

		return {
			url: `/${environment}/notifications/snapshots/`,
		};
	},

	success: (response) => {
		const { notificationSnapshots } = response.data;

		const snapshots = notificationSnapshots.map((snapshot, ii) => {
			const createdAt = new Date(snapshot.createdAt);
			const previousSnapshot = notificationSnapshots[ii - 1];

			const eventDelta = previousSnapshot ? snapshot.totalCount - previousSnapshot.totalCount : 0;
			const failedDelta = previousSnapshot ? snapshot.failedCount - previousSnapshot.failedCount : 0;

			return {
				...snapshot,
				createdAt,
				eventCountDelta: eventDelta,
				failedCountDelta: failedDelta,
				createdAtTime: createdAt.getTime(),
				createdAtFormatted: format(createdAt, "ddd h:mm a"),
			};
		});

		return fromJS({ notificationSnapshots: snapshots, environment: response.data.environment });
	},
});

export const fetchNotificationEmail = CreateProcess({
	method: "GET",
	name: "fetchNotificationEmail",
	type: "[] fetch notification raw email",

	request: (props, { getState }) => {
		const { notificationID } = props;

		const state = getState();
		const environment = getCurrentEnvironmentName(state);

		return {
			url: `/${environment}/notifications/emails/${notificationID}/`,
		};
	},

	success: (response) => response,
});

export const fetchAdminDigests = CreateProcess({
	method: "GET",
	name: "fetchAdminDigests",
	type: "NOTIFICATIONS:Fetch Admin Digests",

	request: (props, { getState }) => {
		const { query = {} } = props;

		const state = getState();
		const environment = getCurrentEnvironmentName(state);
		const queryString = objectToQueryString(query);

		return {
			url: `/${environment}/notifications/admin-digests/?${queryString}`,
		};
	},

	success: (response) => {
		response.data.events.forEach((evt) => {
			const event = evt;

			event.createdAt = objectIDToDate(event._id);
		});

		return fromJS(response.data);
	},
});

export const fetchNotificationCounts = CreateProcess({
	method: "GET",
	name: "fetchNotificationCounts",
	type: "NOTIFICATIONS:GETNOTIFICATIONCOUNTS",

	request: (props = {}, { getState }) => {
		const state = getState();
		const environment = getCurrentEnvironmentName(state);
		const queryString = objectToQueryString(props);

		return {
			url: `/${environment}/notifications/counts/snapshots/?${queryString}`,
		};
	},

	success: (response) => {
		const { notificationCounts } = response.data;

		const counts = notificationCounts.map((snapshot) => {
			const createdAt = new Date(snapshot.date);

			return {
				...snapshot,
				formattedDate: format(createdAt, "ddd h:mm a"),
			};
		});
		return { notificationCounts: counts };
	},
});

export const fetchScheduledNotification = CreateProcess({
	method: "GET",
	name: "fetch scheduled notification",
	type: "NOTIFICATIONS:GETSCHEDULEDNOTIFICATION",

	request: (props, { getState }) => {
		const { notificationID } = props;

		const state = getState();
		const environment = getCurrentEnvironmentName(state);

		return {
			url: `/${environment}/scheduled-notifications/${notificationID}/`,
		};
	},

	success: (response) => {
		const { data } = response;
		const { request } = data;

		console.log(request);

		if (request) {
			request.startTime = moment(toDate(request.start_time * 1000));
		}

		return {
			...data,
			request,
		};
	},
});


